<template>
  <div class="vertical-loader" />
</template>

<script setup>
// Simple loader component that shows a sliding animation line
</script>

<style lang="scss" scoped>
.vertical-loader {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: var(--bs-primary);
  }

  &::after {
    width: 50%;
    animation: mui-loader 1.2s ease-in-out infinite;
  }
}

@keyframes mui-loader {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(200%);
  }
}
</style>
